"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DownloadLinkBox = _interopRequireDefault(require("../DownloadLinkBox/DownloadLinkBox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AliasResults = _ref => {
  let {
    aliases,
    lang,
    translate
  } = _ref;
  const items = aliases.map(el => {
    return {
      link: {
        original_url: el.url,
        url: el.url,
        title: el.title
      }
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-04-bottom sia-margin-02-bottom sia-margin-04-top"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-03  sia-margin-03-bottom"
  }, translate('cms.search.links')), /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: items,
    lang: '',
    isCMS: false,
    openInCurrentTab: true
  }));
};
var _default = exports.default = AliasResults;